import { render, staticRenderFns } from "./AdicionarItemKit.vue?vue&type=template&id=2359d599"
import script from "./AdicionarItemKit.vue?vue&type=script&lang=ts"
export * from "./AdicionarItemKit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports